import "@/styles/components/styled-form.css";

export const setupDropdowns = async (form) => {
  const dropdowns = form.querySelectorAll(".js-navigation-dropdown, .js-dropdown, .userform .field.dropdown");

  if (!dropdowns.length) {
    return;
  }

  const { default: easydropdown } = await import("easydropdown-a11y");
  import("@/styles/components/dropdown.css");

  dropdowns.forEach((el) => {
    const select = el;

    if (!select) {
      return;
    }

    if (select.closest(".edd-root")) {
      return;
    }

    const placeholder = el.querySelector('option[value=""]');

    if (placeholder && !placeholder.hasAttribute("data-placeholder")) {
      placeholder.setAttribute("data-placeholder", true);

      if (!placeholder.textContent) {
        placeholder.textContent = "Select One";
      }
    }

    if (select.classList.contains("js-navigation-dropdown")) {
      select.addEventListener("change", (e) => {
        if (e.target.value) {
          window.location.href = e.target.value;
        }
      });
    }

    const opts = {
      behavior: {
        openOnFocus: true,
        maxVisibleItems: 8,
        liveUpdates: true,
        useNativeUiOnMobile: false,
      },
    };

    easydropdown(select, opts);
  });
};

const setupMasks = async (form) => {
  const fields = form.querySelectorAll('input[type="tel"], input[data-mask-currency], input[data-mask-num-range]');

  if (!fields.length) {
    return;
  }

  const { default: IMask } = await import("imask/esm/imask");
  await import("imask/esm/masked/number");
  await import("imask/esm/masked/pattern");

  fields.forEach((field) => {
    if (field.type === "tel") {
      IMask(field, {
        mask: "(000) 000-0000",
      });
    }

    if (field.dataset.maskCurrency !== undefined) {
      const mask = IMask(field, {
        mask: Number,
        scale: 0,
        thousandsSeparator: ",",
        min: 1,
      });

      field.addEventListener("updateValue", (e) => {
        field.value = e.detail;
        mask.updateValue();
        field.dispatchEvent(new Event("blur"));
      });
    }

    if (field.dataset.maskNumRange !== undefined) {
      const mask = IMask(field, {
        mask: /^(\d+)?(-)?(\d+)?$/,
      });

      field.addEventListener("updateValue", (e) => {
        field.value = e.detail;
        mask.updateValue();
        field.dispatchEvent(new Event("blur"));
      });
    }
  });
};

const setupSpecialFields = (form) => {
  form.querySelectorAll("input[type=file]").forEach((input) => {
    const placeholder = document.createElement("div");
    placeholder.classList.add("file-input-placeholder");

    if (input.value) {
      placeholder.textContent = input.files[0].name;
    } else {
      placeholder.textContent = input.dataset.placeholder;
    }

    input.parentNode.insertBefore(placeholder, input);

    placeholder.addEventListener("click", () => input.click());

    input.addEventListener("change", (e) => {
      placeholder.textContent = e.target.files[0].name;
      placeholder.classList.add("filled");
    });
  });
};

export const setupStyledForm = (form) => {
  setupDropdowns(form);
  setupMasks(form);
  setupSpecialFields(form);
};
